import * as React from 'react';
import { FelaComponent } from 'react-fela';
export const TextSample = ({ fontStyles, children, as }) => {
    const style = {
        paddingBottom: 0,
    };
    return (React.createElement(FelaComponent, { style: [style, fontStyles], as: as || 'p' }, children));
};
//# sourceMappingURL=TextSample.js.map